<form
  [formGroup]="formValidator"
  class="reflection bg-white"
  *ngIf="reflection && allDataIsInit">
  <!-- Inizio del header della riflessione !-->
  <div
    *ngIf="!isUpdating"
    class="d-flex justify-content-between align-items-center">
    <img
      class="reflection-img"
      src="{{
        reflection.project_user.project.filestorage.path
          .changingThisBreaksApplicationSecurity
      }}"
      alt=""
      nz-tooltip
      nzTooltipTitle="{{ reflection.project_user.project.alias }}"
      nzTooltipPlacement="top" />
    <mat-icon
      class="reflection-img secondary-color"
      [matTooltip]="reflection.learnedlesson_typology.alias"
      >{{ selectedTypology.icon }}</mat-icon
    >
  </div>

  <div
    *ngIf="isUpdating"
    class="d-flex justify-content-between align-items-center">
    <div>
      <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="projectMenu">
        <img
          class="reflection-img"
          src="{{
            reflection.project_user.project.filestorage.path
              .changingThisBreaksApplicationSecurity
          }}"
          alt=""
          nz-tooltip
          nzTooltipTitle="{{ reflection.project_user.project.alias }}"
          nzTooltipPlacement="top" />
      </a>
      <nz-dropdown-menu #projectMenu="nzDropdownMenu">
        <ul nz-menu>
          <li
            onKeyDown=""
            (click)="selectProject(project)"
            nz-menu-item
            *ngFor="let project of userProjects.result_project">
            <img
              class="reflection-img small me-2"
              [src]="utilityService.getSanitizeUrl(project.filestorage.path)"
              alt=""
              width="45rem" />
            <span
              class="secondary-color d-flex justify-content-center align-items-center"
              >{{ project.alias }}</span
            >
          </li>

          <li
            onKeyDown=""
            (click)="selectProject(course)"
            nz-menu-item
            *ngFor="let course of userProjects?.result_course">
            <img
              class="reflection-img small me-2"
              [src]="utilityService.getSanitizeUrl(course.filestorage.path)"
              alt=""
              width="45rem" />
            <span
              class="secondary-color d-flex justify-content-center align-items-center"
              >{{ course.alias }}</span
            >
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>

    <div>
      <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="typologyMenu">
        <mat-icon
          class="reflection-img secondary-color"
          [matTooltip]="reflection.learnedlesson_typology.alias"
          >{{ selectedTypology.icon }}</mat-icon
        >
      </a>
      <nz-dropdown-menu #typologyMenu="nzDropdownMenu">
        <ul nz-menu>
          <li
            onKeyDown=""
            (click)="selectTypology(typology)"
            nz-menu-item
            *ngFor="let typology of typologyIconList">
            <span
              class="secondary-color d-flex justify-content-center align-items-center">
              <mat-icon class="secondary-color me-3">{{
                typology.icon
              }}</mat-icon>
              {{ typology.name }}
            </span>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
  </div>
  <!-- Fine del header della riflessione !-->

  <!-- Inizio del body della riflessione !-->
  <div
    class="reflection-body d-flex justify-content-center align-items-center fw-bold">
    <p *ngIf="!isUpdating" class="reflection-text mx-2">
      {{ reflection.description }}
    </p>

    <div class="w-100" *ngIf="isUpdating">
      <textarea
        type="text"
        class="form-control w-100"
        formControlName="description"
        [value]="reflection.description"></textarea>
    </div>
  </div>
  <!-- Fine del body della riflessione !-->
  <!-- Inizio del footer della riflessione !-->
  <div class="d-flex justify-content-between align-items-center">
    <p *ngIf="!isUpdating" class="mb-0 text-muted">
      {{ reflection.learned_at | date: 'dd/MM/yyyy' }}
    </p>
    <div class="text-muted" *ngIf="isUpdating">
      <input
        class="col-12"
        type="date"
        style="border: none; outline: none"
        [max]="today"
        [min]="startDate"
        formControlName="learned_at"
        [value]="reflection.learned_at" />
    </div>
    <div
      class="d-flex justify-content-center align-items-center secondary-color">
      <div class="d-flex justify-content-center align-items-center">
        <div>
          <button
            *ngIf="!isUpdating"
            nz-button
            nzType="default"
            (click)="showModal()">
            <mat-icon onKeyDown="" class="ms-2 icon-btn my-auto"
              >visibility</mat-icon
            >
          </button>
          <nz-modal
            [(nzVisible)]="modalIsVisible"
            [nzFooter]="null"
            [nzClosable]="false"
            [nzCentered]="true"
            (nzOnCancel)="handleCancel()">
            <ng-container *nzModalContent>{{
              reflection.description
            }}</ng-container>
          </nz-modal>
        </div>

        <button *ngIf="isUpdating && !onlyShow">
          <mat-icon
            onKeyDown=""
            (click)="isUpdating = false"
            class="ms-2 icon-btn my-auto"
            >close</mat-icon
          >
        </button>

        <button *ngIf="!onlyShow">
          <mat-icon
            onKeyDown=""
            (click)="isUpdating ? updateReflection() : startEdit()"
            class="ms-2 icon-btn my-auto">
            {{ !isUpdating ? 'edit' : 'done' }}
          </mat-icon>
        </button>
      </div>

      <button (click)="deleteReflection(reflection.id)" *ngIf="!onlyShow">
        <mat-icon class="ms-2 icon-btn my-auto">delete</mat-icon>
      </button>
    </div>
  </div>
  <!-- Fine del footer della riflessione !-->
</form>
